import { AxiosResponse } from "axios";
import Anwendernachricht from "../interface/Anwendernachricht";

const AnwendernachrichtDTO = {
  convertAnwendernachrichtSearchResponse: (
    response: AxiosResponse
  ): Array<Anwendernachricht> => {
    if (response.data) {
      return [...response.data];
    }
    return {} as Array<Anwendernachricht>;
  },
  convertAnwendernachrichtResponse: (
    response: AxiosResponse
  ): Anwendernachricht => {
    if (response.data) {
      return { ...response.data };
    }
    return {} as Anwendernachricht;
  },
};
export default AnwendernachrichtDTO;
